import { call, put, takeEvery } from 'redux-saga/effects';
import { _CALLGETAPI } from '../../api/apiHandler';
import { SUCCESS, _HARDWARE_API_ENDPOINTS } from '../../constants/AppConstants';
import { GetNewPBServicePlanFailure, GetNewPBServicePlanInit, GetNewPBServicePlanSuccess } from './GetNewPrinterBundleServicePlanSlice';
import { addPromotionsToPayload } from '../../constants/AppMethod';

function _GETNPBSERVICEPLAN(model, promotions) {
    const endpoint = _HARDWARE_API_ENDPOINTS.GET_NEW_PRINTER_BUNDLE_SERVICE_PLAN
    let payload;

    payload = {
        params: {
            planType: 'new',
            deviceOption: "purchase_new", //for newPrinterBundle
            includeHiddenPlans: "false",
            ...(model && { model })
        }
    }
    if (model && promotions) {
        addPromotionsToPayload(payload, promotions)
    }

    return _CALLGETAPI(endpoint, payload)
        .then(response => {
            return response;
        })
        .catch((error) => {
            throw error;
        });
}

function* handleNewPrinterBundleServicePlan(action) {
    try {
        const model = action?.payload?.model
        const promotions = action?.payload?.promotions
        const newPBservicePlan = yield call(_GETNPBSERVICEPLAN, model, promotions);
        if (newPBservicePlan.actionStatus.toUpperCase() === SUCCESS) {
            yield put(GetNewPBServicePlanSuccess({ servicePlan: newPBservicePlan, model: model }));
        } else {
            yield put(GetNewPBServicePlanFailure(newPBservicePlan));
        }
    } catch (e) {
        /**
         * This conditional statement is added to avoid
         * displaying error message in view while logout from app
         */
        if (e instanceof TypeError === false && e.message !== "401") {
            yield put(GetNewPBServicePlanFailure(e.message));
        }
    }
}

export default function* watchGetNewPrinterBundleServicePlan() {
    yield takeEvery(GetNewPBServicePlanInit.type, handleNewPrinterBundleServicePlan);
}

